import { mapActions, mapState } from 'vuex';
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';

const likeType = 'ARTICLE';
export default {
  props: {},
  data() {
    return {
      isLike: false
    };
  },
  computed: {
    ...mapState({
      curLang: state => state.curLang,
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      gameId: state => state.urlParams.gameId,
      loginAccount: state => state.urlParams.loginAccount,
      roleId: state => state.urlParams.roleId
    }),
    faqId() {
      return this.$route.query.faqId;
    },
    showLike() {
      return this.loginAccount && this.gameId && this.roleId;
    }
  },
  methods: {
    ...mapActions(['doLikeAction', 'getCharLikeNum']),
    async like() {
      try {
        await this.doLikeAction({
          gameId: this.gameId,
          id: this.faqId,
          loginAccount: this.loginAccount,
          action: 'LIKE',
          likeType: likeType,
          roleId: this.roleId,
          appLanguage: this.curLang,
          language: this.curLang
        });
        this.isLike = true;
      } catch (e) {
        console.log(e);
      }
    },
    async cancelLike() {
      try {
        await this.doLikeAction({
          gameId: this.gameId,
          id: this.faqId,
          loginAccount: this.loginAccount,
          action: 'CANCEL_LIKE',
          likeType: likeType,
          roleId: this.roleId,
          appLanguage: this.curLang,
          language: this.curLang
        });
        this.isLike = false;
      } catch (e) {
        console.log(e);
      }
    },
    async updateLikeData() {
      try {
        const data = await this.getCharLikeNum({
          gameId: this.gameId,
          id: this.faqId,
          loginAccount: this.loginAccount,
          likeType: likeType,
          appLanguage: this.curLang,
          language: this.curLang
        });
        this.isLike = Boolean(+data.IS_LIKE) || false;
      } catch (e) {
        console.log(e);
      }
    },
    handleLike() {
      if (this.isLike) {
        this.cancelLike();
        clickButton({
          btnName: 'clickCancelLike',
          locationKey: locationType.faqDetailPage,
          otherParams: {
            faqClassId: this.faqId
          }
        });
      } else {
        this.like();
        clickButton({
          btnName: 'clickLike',
          locationKey: locationType.faqDetailPage,
          otherParams: {
            faqId: this.faqId
          }
        });
      }
    }
  }
};
